import { connect } from 'react-redux';
import Component from './component';
import setActionApprovalDocIDRoute from '../../actions/approvaldocs/actionapprovaldocidroute';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  handleSetActionApprovalDocIDRoute: async (ActionApprovalDocID) => {
    await dispatch(await setActionApprovalDocIDRoute(ActionApprovalDocID));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
